// extracted by mini-css-extract-plugin
export default {"timeUnitText":"AgeCell_timeUnitText__0NeR4"};